export const EMPLOYEE_TYPES = ['employee', 'manager', 'admin'];
